import { ReactComponent as Icon } from "../files/headshots.svg";

import ISVGIconProps from "../ISVGIconProps";

const HeadshotsIcon = ({
    fill,  
    style = {},
}: ISVGIconProps) => {   
    return (
        <div style={style}>
            <Icon
                fill={fill} 
                style={style}        
            />
        </div>
    );
};

export default HeadshotsIcon;
